/** @jsx jsx */
import React from 'react'
import { Box, useTheme } from '@chakra-ui/core'
import { css, jsx } from '@emotion/core'

type orderType = number | 'first' | 'last' | 'none' | null

const orderToNum = (order: orderType | orderType[]): number[] => {
  const orderList: orderType[] = Array.isArray(order) ? order : [order]
  return orderList.map((x) => {
    if (x === 'first') return -9999
    else if (x === 'last') return 9999
    else if (x === 'none' || !x) return 0
    return x
  })
}

const GridItem = ({
  children,
  colSpan = 1,
  colStart = null,
  colEnd = null,
  rowSpan = 1,
  rowStart = null,
  rowEnd = null,
  order = 0,
  ...rest
}: Props) => {
  const theme = useTheme()

  const gridItemRule = (
    breakpoints: any,
    values: number | number[],
    rule: any
  ): string => {
    if (!values) return ''
    const valArr: number[] = Array.isArray(values) ? values : [values]
    // The first value we pass in is from 0 width to 480px width.
    // so we need to start one off from the theme breakpoints.
    const usedBreakpoints: string[] = breakpoints.slice(0, valArr.length - 1)

    const mediaQueries: string = usedBreakpoints
      .map(
        (bp, i) => `
          @media (min-width: ${bp}) {
            ${rule(valArr[i + 1])}
          }
        `
      )
      .join(' ')
    // This is the first value for the first item passed in the responsive array
    return `
      ${rule(valArr[0])}
      ${mediaQueries}
    `
  }

  return (
    <Box
      {...rest}
      css={css`
        ${gridItemRule(
          theme.breakpoints,
          colSpan,
          (val: number): string => `grid-column: span ${val} / span ${val};`
        )}
        ${gridItemRule(
          theme.breakpoints,
          colStart,
          (val: number): string => `grid-column-start: ${val};`
        )}
        ${gridItemRule(
          theme.breakpoints,
          colEnd,
          (val: number): string => `grid-column-end: ${val};`
        )}
        ${gridItemRule(
          theme.breakpoints,
          rowSpan,
          (val: number): string => `grid-row: span ${val} / span ${val};`
        )}
        ${gridItemRule(
          theme.breakpoints,
          rowStart,
          (val: number): string => `grid-row-start: ${val};`
        )}
        ${gridItemRule(
          theme.breakpoints,
          rowEnd,
          (val: number): string => `grid-row-end: ${val};`
        )}
        ${gridItemRule(
          theme.breakpoints,
          //@ts-ignore
          orderToNum(order),
          (val: number): string => `order: ${val};`
        )}
      `}
    >
      {children}
    </Box>
  )
}

interface Props {
  children: string | React.ReactNode
  colSpan?: number[] | number | null
  colStart?: number[] | number | null
  colEnd?: number[] | number | null
  rowSpan?: number[] | number | null
  rowStart?: number[] | number | null
  rowEnd?: number[] | number | null
  order?: orderType[] | orderType
  mt?: number[] | number | null
  mb?: number[] | number | null
  my?: number[] | number | null
  pb?: number[] | number | null
  p?: number[] | number | null
  height?: string
  maxHeight?: string
  backgroundColor?: string
}

export default GridItem
